<template>
    <div class="export">
		<!-- <base-button type="primary" simple @click="getApiData()" >Получить АПИ Список форматов</base-button> -->
		<h4>Список форматов</h4>
		<!-- <pre>{{ ApiData }}</pre> -->


		
		<card
			v-loading.fullscreen.lock="$GVO.fullscreenLoading"
			element-loading-text="Загрузка данных..."
			element-loading-spinner="el-icon-loading"
			element-loading-background="rgba(0, 0, 0, 0.8)">
			<!-- <h4 v-if="this.objApimsg && this.objApimsg!=''" class="text-center"> <i class="tim-icons icon-alert-circle-exc text-danger mb-2 mr-2"></i> {{this.objApimsg}}</h4> -->

			<el-table :data="ApiData" style="width: 100%;" ref="ApiData">
				<el-table-column
					label="ID"
					property="id"
					width="80"
					sortable
				>
				</el-table-column>
				<el-table-column 
					width="80"
					label="act"
					property="act"
				>
					<!-- <template slot-scope="scope">{{ $GVO.number_format(scope.row.amount,0,'.',' ') }}</template> -->
				</el-table-column>
				<el-table-column 
					min-width="220"
					label="name"
					property="name"
					sortable
				>
					<!-- <template slot-scope="scope">
						<a :href="'/data/staff/id/'+scope.row.staff_code">{{scope.row.staff_code}}</a>
					</template> -->
				</el-table-column>
				<el-table-column 
					min-width="220"
					label="type"
					property="type"
				>
				</el-table-column>
				<el-table-column 
					min-width="220"
					label="title"
					property="title"
				>
				</el-table-column>
				
				<el-table-column 
					min-width="220"
					label="Получить правила формата"
					property="id"
				>
					<template v-slot="scope">
						<!-- <a :href="'/data/staff/id/'+scope.row.staff_code">{{scope.row.staff_code}}</a> -->
						<base-button type="success" simple @click="getFormatRules(scope.row.id)">Получить список правил в рамках этого формата</base-button>
					</template>
				</el-table-column>
			</el-table>
		</card>	
		<Pagination class="mt-3" :class="[{'': parseInt(masObjects_total) > 0}, {'d-none': parseInt(masObjects_total) < 1}]"
			:type="'info'" 
			:total="parseInt(masObjects_total)" 
			:perPage="parseInt(count2page)"
			:value="parseInt(typeof objGetParams.p == 'undefined' ? 1:objGetParams.p)"
			:pClick="pClick">
		</Pagination>		

    </div>
</template>
<script>

/* Сломалась реактивность на объекте или массиве: 
	Этот чудесный кослыль родился потому что VUE не может нормально следить за массивами и теряется реактивность
	https://v2.vuejs.org/v2/guide/reactivity.html#Change-Detection-Caveats

Для объекта:
	this.$set(this.objChosenTP,this.ApiData[i].siteId, {'choise':'','cost':0, 'phone':{"contact_id":"","contact_type":"1","contact_value":"","contact_view":"","contact_group":"phone"}});
Для Массива:
	Vue.set(this.masCheckListParams,obj_index, [{val_id:obj_index, elements: masElements}]);
*/


import { Table, TableColumn,  Select, Option, Tooltip, Button } from 'element-ui';
// import ReFilterBtn from 'src/our_components/FilterPrinter/ReFilterBtn.vue';
// import ReFilter from 'src/our_components/FilterPrinter/ReFilter.vue';


import Pagination from 'src/our_components/RePagination';

export default {
	name: 'export-formats-page',
	components: {
	    [Table.name]: Table,
    	[TableColumn.name]: TableColumn,
        [Option.name]: Option,
        [Select.name]: Select,
        [Tooltip.name]: Tooltip,
        [Button.name]: Button,
		// ReFilterBtn,
        // ReFilter,
        
		Pagination,
	},
	data() {
		return {
			ApiData: [],
			// FormatRules: [],
			// masAllFilterParams: this.currentFilterConfig(),
			objGetParams:{},
			bShowFilter: false,
			masObjects_total: 0,
			count2page: 10,
		};
	},
	methods: {
		getApiData(){
		//Список форматов - exportEditor.GET - придут: name, type, title
			this.$GVO.ApiCall('exportEditor.GET',{flt:{empty:true}})
			.then((objApi) => {
				if(objApi.success === true){
					this.masObjects_total = 0;
					// console.log('exportEditor.GET', objApi);
					if(objApi.data.length > 0){
						this.ApiData = objApi.data;
						if(objApi.total!=undefined) { this.masObjects_total=objApi.total; }
					}
				} else {
					this.ApiData = [];
					this.masObjects_total=0;
				}
			}).catch(errorObjApi => {this.ApiData = []; this.masObjects_total=0; console.error(errorObjApi);});
		},
		getFormatRules(format_id){

			this.$router.push({path: '/data/export/id/'+format_id});

			// this.$GVO.ApiCall('exportEditor.rules_GET',{flt:{formatId:format_id}})
			// .then((objApi) => {
			// 	if(objApi.success === true){
			// 		// this.masObjects_total = 0;
			// 		// console.log('exportEditor.GET', objApi);
			// 		if(objApi.data.length > 0){
			// 			this.FormatRules = objApi.data;
			// 			// if(objApi.total!=undefined) { this.masObjects_total=objApi.total; }
			// 		}
			// 	} else {
			// 		this.FormatRules = [];
			// 		// this.masObjects_total=0;
			// 	}
			// }).catch(errorObjApi => {this.FormatRules = []; console.log(errorObjApi);});
		
		},
		getFilter(){
			// this.objGetParams = this.$GVO.GetAllGet();
			// let filter = {};
			// if (!this.$GVO.isEmpty(this.objGetParams)) {
			// 	//console.log('getClients',this.objGetParams);
			// 	filter = this.objGetParams;
			// }
			// return filter;
		},
		// getApiData(){

			// let filter = this.getFilter();
			// this.$GVO.ApiCall('billing.getBill',{flt:{...filter}})
			// .then((objApi) => {
			// 	if(objApi.success === true){
			// 		this.arrMonthsData = [];
			// 		this.masObjects_total = 0;
			// 		console.log('getApiData',objApi.data);
			// 		for (const strMontgh in objApi.data) {
			// 			if (Object.hasOwnProperty.call(objApi.data, strMontgh)) {
			// 				this.arrMonthsData.push(objApi.data[strMontgh]);
			// 			}
			// 		}
			// 		if(objApi.data.length > 0){
			// 			if(objApi.total!=undefined) { this.masObjects_total=objApi.total; }
			// 		}
			// 	}else{
			// 		this.arrMonthsData = [];
			// 		this.masObjects_total=0;
			// 	}
			// }).catch(errorObjApi => {this.arrMonthsData = []; this.masObjects_total=0; console.log(errorObjApi);});
			
		// },
		currentFilterConfig(){
			// this.$GVO.ApiCall('billing.GET_FILTER',{})
			// 	.then((objApi) => {
			// 		if(objApi.success){
			// 			this.masAllFilterParams = this.$GVO.unlinkObject(objApi.config);
			// 			eventEmitter.$emit('OnFilterConfigLoad',  this.masAllFilterParams);
			// 		}
			// 	})
			// 	.catch(errorObjApi => console.log(errorObjApi));
			// return [];
		},
		pClick(e){
			this.objGetParams['p'] = parseInt(e);
			this.OnFilterApply();
		},
		OnFilterApply(data){ 
			// if(typeof data != 'undefined' && typeof this.objGetParams['p'] != 'undefined' && bFromObj==false){
			// 	delete this.objGetParams['p'];
			// }

			// for (const key in this.objGetParams) {
			// 	if (Object.hasOwnProperty.call(this.objGetParams, key)) {
			// 		if(this.objGetParams[key] == '') delete this.objGetParams[key];
			// 		if(this.objGetParams[key] == '{"inputText":"","selectedVal":""}') delete this.objGetParams[key];
			// 	}
			// }
			
			// let strItogGetParams = this.$GVO.ObjToQueryString(this.objGetParams).substr(1);
			// //console.log('OnFilterApply',location.pathname+'?'+strItogGetParams,this.objGetParams);
			// this.$router.push({path: location.pathname+'?'+strItogGetParams});
			// eventEmitter.$emit('OnFilterApply', this.objGetParams);	
			this.getApiData();		
		},


	},		
	mounted() {
		// this.objGetParams = this.$GVO.GetAllGet();
		this.getApiData();
	}
};
</script>
<style scoped>


</style>
